import { FormattedMessage } from 'react-intl';

import { DialogProps, DialogTitle, List } from '@mui/material';

import { AccountBalanceV2, AccountId } from '@arrived/models';
import { useGetAccountBalanceQuery } from '@arrived/queries';

import { DataStateHandler } from '../../../DataStateHandler';
import { PortfolioDialog } from './PortfolioDialog';

import { AppreciationDetailsList } from '../../common/detailsList';

export interface AppreciationDialogProps extends DialogProps {
  accountId?: AccountId;
}

export const AppreciationDialog = ({ accountId, ...rest }: AppreciationDialogProps) => {
  const accountBalanceState = useGetAccountBalanceQuery(accountId);

  return (
    <PortfolioDialog {...rest}>
      <DataStateHandler queries={[accountBalanceState]}>
        {(accountBalanceState) => <AppreciationDialogContent accountBalance={accountBalanceState.data} />}
      </DataStateHandler>
    </PortfolioDialog>
  );
};

interface AppreciationDialogContentProps {
  accountBalance: AccountBalanceV2;
}

const AppreciationDialogContent = ({ accountBalance }: AppreciationDialogContentProps) => {
  const {
    appreciation: { totalAppreciation },
    initialInvestment,
    totalValue,
  } = accountBalance;

  return (
    <>
      <DialogTitle>
        <FormattedMessage id="appreciation-returns" defaultMessage="Appreciation Returns" />
      </DialogTitle>
      <List>
        <AppreciationDetailsList
          allTimeAppreciation={totalAppreciation}
          initialInvestment={initialInvestment}
          totalBalance={totalValue}
        />
      </List>
    </>
  );
};
